'use strict';exports.__esModule = true;exports.ERROR_KEYS = exports.ENTITY_TYPES = exports.ROUTES_ADDITIONAL = exports.ROUTES_PATHS = exports.COUNTRIES_LIST = exports.DEFAULT_DESCRIPTION_LENGTH = exports.DEFAULT_MAIN_IMAGE = exports.MAIN_IMAGES_MOBILE = exports.MAIN_IMAGES = exports.fbLink = exports.publishFormErrorNames = exports.publishFormLocationErrors = exports.googleAdClient = exports.managePropertyActions = exports.formatImageLink = exports.getFilteredPropertyTypes = exports.columnsDefaultState = exports.columnOptions = exports.publishFormFieldsForSave = exports.publishProjectFormFieldsForSave = exports.projectStatuses = exports.packageIcons = exports.onMapLogoSocials = exports.onMapLogoMobileBlue = exports.onMapLogoMobile = exports.onMapLogoWhite = exports.onMapLogoBlue = exports.cloudinaryBaseUrls = exports.VAT = exports.constructionYearMax = exports.constructionYearMin = exports.privacyTermsTabs = exports.myStaffViews = exports.myAccountViews = exports.reportTypes = exports.issueTypes = exports.analyticsEventAction = exports.countOfPropertiesShowTime = exports.mouseFlowSiteId = exports.viewsPeriodOnChart = exports.desktopHiddenFooterPart = exports.mobileHiddenFooterPart = exports.searchFooterHeight = exports.mobileHeaderHeight = exports.desktopHeaderHeight = exports.mobileFavoritesSwitcherHeight = exports.mobileFiltersHeight = exports.filtersHeight = exports.playmarketLink = exports.appStoreLink = exports.appStoreId = exports.centeredModalStyle = exports.cleanModalStyle = exports.clearFiltersInitialValues = exports.initialFieldsValuesForMobileFilters = exports.advancedFiltersInitialValues = exports.propertyFiltersInitialValues = exports.contactUsUsage = exports.languageFontOverride = exports.localesWithEnglishAddress = exports.localesWithShortenFooterLinks = exports.alwaysDisplayedPropertyData = exports.realEstateTermsDefinitionsLink = exports.subscriptionGeneralTopicId = exports.israelCode = exports.phoneСodeCountryRegex = exports.phoneNumberRegex = exports.mapboxPinInfoWindowMetrics = exports.pinInfoWindowMetrics = exports.ourContacts = exports.getSupportEmail = exports.supportEmail = exports.temporaryEmailEnding = exports.requestErrorStatusCodes = exports.inputStyleTheme = exports.swiperStyles = exports.reactSelectStyles = exports.sentry = exports.rigthKey = exports.leftKey = undefined;exports.escKey = exports.enterKey = exports.propertyDefaultImage = exports.videoFullModifier = exports.fullModifier = exports.galleryModifierMobile = exports.galleryModifier = exports.propertyModifier = exports.portfolioThumbnailModifier = exports.professionalsSliderModifier = exports.companyLogoAspectFitModifier = exports.projectDetailsModifier = exports.projectThumbnailModifier = exports.sliderThumbnailModifier = exports.thumbnailModifier = exports.TAB_PROJECT_ID = exports.STATUS_PROJECT = exports.imageModifierTypes = exports.imageConfig = exports.getAssetsBaseUrl = exports.contactUsRealtorDevicesMobile = exports.contactUsRealtorDevices = exports.purpleStamp = exports.brokerCommunityLogo = exports.brokerAssociationStamp = exports.brokerCommunityStamp = exports.contactUsRealtorImageMobile = exports.contactUsRealtorImage = exports.homePageMobileAppBanner = exports.homePageBottomBannerMobile = exports.homePageHomeBanner = exports.homePageImageMobile = exports.homePageImage = exports.realtorLandingPackagesBackground = exports.realtorLandingBottomBackground = exports.realtorLandingImageMobile = exports.realtorLandingImage = exports.headerVideo = exports.getAssetsActionUrl = exports.getCloudinaryActionUrl = exports.cloudinaryActions = exports.cloudinaryContentTypes = exports.CLOUDINARY_BASE_URL = exports.CLOUDINARY_UPLOAD_PRESET = exports.CLOUDINARY_API_SECRET = exports.CLOUDINARY_API_KEY = exports.CLOUDINARY_CLOUD_NAME = exports.socialNetworks = exports.publishConfig = exports.sortingOption = exports.leadsSortingConfig = exports.SORTING_UNVIEWED_FIRST = exports.SORTING_VIEWED_FIRST = exports.SORTING_HIGHEST_PRICE = exports.SORTING_LOWEST_PRICE = exports.SORTING_NEWEST_FIRST = exports.SORTING_UPDATE_DATE = exports.optionTypesPropertyLocation = exports.optionTypesValuesWithAll = exports.optionTypesValues = exports.defaultOptionType = exports.getOptionTypes = exports.getSectionsNames = exports.getProfessionalsTypes = exports.PROFESSIONAL_TYPE_BROKER = exports.PROFESSIONALS_TYPES = exports.sections = exports.optionTypes = exports.searchPagePrefix = exports.propertiesSlidersTypes = exports.PREFERRED_EMPLOYEES_COUNTRIES = exports.PREFERRED_COUNTRIES = exports.buyMoreQuestionsModalType = exports.authenticationModalType = exports.paginationParams = exports.storage = exports.shareUrl = exports.mailingApiURL = exports.locationsApiURL = exports.analyticsApiURL = exports.apiURL = exports.isProd = exports.optionsActivity = exports.bathToiletsOptions = exports.roomOptionsTitles = exports.roomOptions = exports.zoomForAgencyPinDisplay = exports.mapDefaultOptions = exports.userAuthenticationPageTabs = exports.userAuthenticationTabs = exports.drawOnMapOptions = exports.mapboxConfig = exports.mapboxEnvs = exports.googleReCaptchaConfig = exports.googleSdkConfig = exports.remarketing = exports.analytics = exports.languages = exports.language = exports.israelTranslations = undefined;var _leadsSortingConfig, _MAIN_IMAGES, _MAIN_IMAGES_MOBILE; /* eslint-disable max-len,quote-props,dot-notation */
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _difference = require('lodash/difference');var _difference2 = _interopRequireDefault(_difference);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _config = require('./config');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// NOTE: All process.env.{VAR} should be defined in ./internals/webpack/env-vars.js

var israelTranslations = exports.israelTranslations = {
  he: 'ישראל',
  en: 'Israel',
  ru: 'Израиль',
  fr: 'Israel' };


var language = exports.language = {
  default: 'he',
  fallback: 'en',
  supportedLanguages: ['he', 'en', 'ru', 'fr'],
  supportedForeignLanguages: ['en', 'he', 'ru', 'fr'],
  ignoredLanguages: ['ru', 'fr'] };


language.languages = (0, _difference2.default)(language.supportedLanguages, language.ignoredLanguages);

var languages = exports.languages = [
{ label: 'עברית',
  value: 'he',
  flagIcon:
  _react2.default.createElement('span', { className: 'icon-israel' },
    _react2.default.createElement('span', { className: 'path1' }),
    _react2.default.createElement('span', { className: 'path2' }),
    _react2.default.createElement('span', { className: 'path3' }),
    _react2.default.createElement('span', { className: 'path4' })) },


{ label: 'English',
  value: 'en',
  flagIcon:
  _react2.default.createElement('span', { className: 'icon-united-kingdom' },
    _react2.default.createElement('span', { className: 'path1' }),
    _react2.default.createElement('span', { className: 'path2' }),
    _react2.default.createElement('span', { className: 'path3' }),
    _react2.default.createElement('span', { className: 'path4' }),
    _react2.default.createElement('span', { className: 'path5' }),
    _react2.default.createElement('span', { className: 'path6' }),
    _react2.default.createElement('span', { className: 'path7' }),
    _react2.default.createElement('span', { className: 'path8' }),
    _react2.default.createElement('span', { className: 'path9' }),
    _react2.default.createElement('span', { className: 'path10' }),
    _react2.default.createElement('span', { className: 'path11' }),
    _react2.default.createElement('span', { className: 'path12' }),
    _react2.default.createElement('span', { className: 'path13' }),
    _react2.default.createElement('span', { className: 'path14' }),
    _react2.default.createElement('span', { className: 'path15' }),
    _react2.default.createElement('span', { className: 'path16' }),
    _react2.default.createElement('span', { className: 'path17' }),
    _react2.default.createElement('span', { className: 'path18' })) },


{ label: 'Русский',
  value: 'ru',
  flagIcon:
  _react2.default.createElement('span', { className: 'icon-russia' },
    _react2.default.createElement('span', { className: 'path1' }),
    _react2.default.createElement('span', { className: 'path2' }),
    _react2.default.createElement('span', { className: 'path3' }),
    _react2.default.createElement('span', { className: 'path4' })) },


{ label: 'Français',
  value: 'fr',
  flagIcon:
  _react2.default.createElement('span', { className: 'icon-france' },
    _react2.default.createElement('span', { className: 'path1' }),
    _react2.default.createElement('span', { className: 'path2' }),
    _react2.default.createElement('span', { className: 'path3' })) }];




var analytics = exports.analytics = {
  analyticsProvider: 'google',
  google: {
    trackingId: process.env.GOOGLE_TRACKING_ID || 'UA-XXXXX-X',
    tagManagerId: process.env.GOOGLE_TAG_MANAGER_ID || 'GTM-XXXX' } };



var remarketing = exports.remarketing = {
  url: 'https://www.googleadservices.com/pagead/conversion_async.js',
  conversionId: process.env.GOOGLE_CONVERSION_ID || 'xxxxxxxx',
  pageType: 'searchresults' };


var googleSdkConfig = exports.googleSdkConfig = {
  libUrl: 'https://maps.googleapis.com/maps/api/js?libraries=places,geometry',
  staticMapUrl: 'https://maps.googleapis.com/maps/api/staticmap',
  staticMapPin: 'https://res.cloudinary.com/onmap-prod/image/upload/v1571930138/general/pin.png',
  version: '3.50',
  clustererLibUrl: '/scripts/markerclusterer.min.js',
  authLibUrl: 'https://accounts.google.com/gsi/client',
  apiKey: process.env.GOOGLE_API_KEY || 'AIzaSyCy2CpOzaKmsFSHlGs0sGDjotJTMQlctNw',
  authClientId: process.env.GOOGLE_AUTH_CLIENT_ID || '289746370932-ls6omq0mkmtvpj8b561rq6cqed7a8mbp.apps.googleusercontent.com',
  geocodeUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
  streetViewPhotoUrl: 'https://maps.googleapis.com/maps/api/streetview',
  restrictionCountry: 'il',
  styles: {
    fillOpacity: 0,
    strokeWeight: 2,
    strokeColor: '#0f86ba' },

  polygonSimplificationTolerance: 5.0,
  // For calculating a top padding, y = kx + b
  marginEquation: {
    k: 0.0228598069953936333012,
    b: -0.0000093244838777165543 },

  translateUrl: 'https://translation.googleapis.com/language/translate/v2' };


var googleReCaptchaConfig = exports.googleReCaptchaConfig = {
  url: 'https://www.google.com/recaptcha/api.js?render=explicit&hl=',
  apiKey: process.env.GOOGLE_RECAPTCHA_KEY || '6LdZGRkUAAAAAAx1GtAd5JlfHg4N3OTnmVAhHWkj' };


var mapboxEnvs = exports.mapboxEnvs = {
  account: process.env.MAPBOX_ACCOUNT || 'alexander7',
  apiKey: process.env.MAPBOX_API_KEY || 'pk.eyJ1IjoiYWxleGFuZGVyNyIsImEiOiJja2M5YzY0MWoxank3MzJsbWQyeHkyOWtpIn0.Z1jWIcBnIrQflvC1SmtBUw',
  styles: {
    he: process.env.MAPBOX_STYLE_HE || 'ckc9couis16cb1inyo0f40atw',
    en: process.env.MAPBOX_STYLE_EN || 'ckc9cw4zq42mp1iowm7ewbf2d',
    ru: process.env.MAPBOX_STYLE_RU || 'ckc9cyucm42n81iqmfdsygekj',
    fr: process.env.MAPBOX_STYLE_FR || 'ckc9d11c242n01ipi8p1a3mo6' } };



var mapboxConfig = exports.mapboxConfig = {
  polygonSimplificationTolerance: 5.0,
  styleBaseLink: 'mapbox://styles/' + mapboxEnvs.account,
  staticMapBaseUrl: 'https://api.mapbox.com/styles/v1/' + mapboxEnvs.account,
  staticMapPin: 'https://res.cloudinary.com/onmap-prod/image/upload/v1571930138/general/pin.png',
  staticMapPin2x: 'https://res.cloudinary.com/onmap-prod/image/upload/w_40,h_40/v1571930138/general/pin.png',
  rtlPluginUrl: 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js' };


var drawOnMapOptions = exports.drawOnMapOptions = {
  fillOpacity: 0.25,
  fillColor: '#0f86ba',
  strokeColor: '#0f86ba',
  strokeWeight: 2 };


var userAuthenticationTabs = exports.userAuthenticationTabs = {
  SIGN_IN: 1,
  NEW_ACCOUNT: 2 };


var userAuthenticationPageTabs = exports.userAuthenticationPageTabs = {
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up' };


var mapDefaultOptions = exports.mapDefaultOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  zoom: 11,
  cityZoom: 11,
  minZoom: 8,
  maxZoom: 21,
  defaultPinIcon: '/icons/pin.svg',
  center: {
    lat: 31.9430284,
    lng: 34.7967823 },

  // Docs -> http://htmlpreview.github.io/?https://github.com/googlemaps/v3-utility-library/blob/master/markerclustererplus/docs/reference.html
  clustererOptions: {
    imagePath: '/icons/pin',
    imageExtension: 'svg',
    imageSizes: [40, 50],
    styles: [{
      width: 32,
      height: 32,
      anchorIcon: [40, 20],
      anchorText: [0, 0],
      fontFamily: 'Arial-BoldMT, Arial, serif',
      fontWeight: 'bold',
      lineHeight: 32,
      textSize: 10,
      textColor: '#000',
      url: '/icons/big-pin.svg' // Overwrites
    }],
    clusterClass: 'clusterPin',
    maxZoom: 14,
    gridSize: 30,
    cityGridSize: 100,
    enableRetinaIcons: true,
    averageCenter: true,
    minimumClusterSize: 2,
    zoomOnClick: true },

  zoomControlOptions: {
    zoomControl: true,
    position: 1 },

  GLOBE: {
    WIDTH: 256, // constants in Google's map projection
    HEIGHT: 256 },

  fullscreenControl: false };


var zoomForAgencyPinDisplay = exports.zoomForAgencyPinDisplay = 12;

var roomOptions = exports.roomOptions = [
{ id: 1, label: '1', value: '1' },
{ id: 2, label: '2', value: '2' },
{ id: 3, label: '3', value: '3' },
{ id: 4, label: '4', value: '4' },
{ id: 5, label: '5', value: '5' },
{ id: 6, label: '+6', value: '6' }];

var roomOptionsTitles = exports.roomOptionsTitles = function roomOptionsTitles(translate) {return [
  { id: 1, label: '' + translate('room'), value: 1 },
  { id: 2, label: '2 ' + translate('rooms'), value: 2 },
  { id: 3, label: '3 ' + translate('rooms'), value: 3 },
  { id: 4, label: '4 ' + translate('rooms'), value: 4 },
  { id: 5, label: '5 ' + translate('rooms'), value: 5 },
  { id: 6, label: '+6 ' + translate('rooms'), value: 6 }];};


var bathToiletsOptions = exports.bathToiletsOptions = function bathToiletsOptions(translate) {return [
  { id: 'all', label: '' + translate('search_box', 'searchContainer', 'all'), value: 'all' },
  { id: 1, label: '1', value: '1' },
  { id: 2, label: '2', value: '2' },
  { id: 3, label: '3', value: '3' },
  { id: 4, label: '4', value: '4' },
  { id: 5, label: '+5', value: '5' }];};


var optionsActivity = exports.optionsActivity = function optionsActivity(translate) {return [
  { value: 'all', label: translate('managePage', 'allStatuses').toString() },
  { value: true, label: translate('managePage', 'active').toString() },
  { value: false, label: translate('managePage', 'inactive').toString() }];};


var isDev = process.env.DEPLOYMENT_TYPE === 'dev';
var isProd = exports.isProd = process.env.DEPLOYMENT_TYPE === 'prod';
// Probably undefined due to webpack define plugin
var port = process.env.PORT || 8000;

// TODO: Manage this via .env files and take values straight from process.env.*
var allHosts = {
  development: {
    self: 'http://localhost:' + port,
    mainApi: _config.targetApi + '/v1',
    analyticsApi: 'https://dev-hermione.onmap.co.il/v1',
    locationsApi: 'https://dev-locus.onmap.co.il/v1',
    mailingApi: 'https://dev-hedwig.onmap.co.il/v1' },

  production: {
    self: isDev ?
    'https://dev.onmap.co.il' :
    'https://www.onmap.co.il',
    mainApi: _config.targetApi + '/v1',
    analyticsApi: isDev ?
    'https://dev-hermione.onmap.co.il/v1' :
    'https://hermione.onmap.co.il/v1',
    locationsApi: isDev ?
    'https://dev-locus.onmap.co.il/v1' :
    'https://locus.onmap.co.il/v1',
    mailingApi: isDev ?
    'https://dev-hedwig.onmap.co.il/v1' :
    'https://hedwig.onmap.co.il/v1' } };


allHosts.test = allHosts.development;
var hosts = allHosts[process.env.NODE_ENV || 'development'];

var apiURL = exports.apiURL = hosts.mainApi;
var analyticsApiURL = exports.analyticsApiURL = hosts.analyticsApi;
var locationsApiURL = exports.locationsApiURL = hosts.locationsApi;
var mailingApiURL = exports.mailingApiURL = hosts.mailingApi;
var shareUrl = exports.shareUrl = hosts.self;

var storage = exports.storage = {
  value: global.localStorage };


var paginationParams = exports.paginationParams = { skip: 24, limit: 24 };

var authenticationModalType = exports.authenticationModalType = {
  RESET_PASSWORD: 'resetPassword',
  CHANGE_PASSWORD: 'changePassword',
  FORGOT_PASSWORD: 'forgotPassword',
  TOKEN_INVALID: 'tokenInvalid',
  PASSWORD_UPDATED: 'passwordUpdated',
  PASSWORD_UPDATE_FAILED: 'passwordUpdateFailed',
  PASSWORD_CHANGED: 'passwordChanged',
  PASSWORD_CHANGE_FAILED: 'passwordChangeFailed',
  SEND_EMAIL_SUCCESS: 'sendEmailSuccess',
  SEND_EMAIL_FAIL: 'sendEmailFail',
  DEFAULT: 'authentication',
  UPDATE_TEMPORARY_PROFILE: 'updateTemporaryProfile' };


var buyMoreQuestionsModalType = exports.buyMoreQuestionsModalType = {
  QUESTIONS_PRICING: 'questionsPricing',
  CLIENT_INFO_FORM: 'clientInfoForm' };


var PREFERRED_COUNTRIES = exports.PREFERRED_COUNTRIES = ['il', 'gb', 'ua', 'fr', 'ru'];
var PREFERRED_EMPLOYEES_COUNTRIES = exports.PREFERRED_EMPLOYEES_COUNTRIES = ['il'];

var propertiesSlidersTypes = exports.propertiesSlidersTypes = {
  FOR_SALE: 'buy',
  FOR_RENT: 'rent',
  UP_TO: 'max',
  PROPERTY_TYPE: 'type',
  PROJECTS: 'projects',
  FAVORITES: 'favorites' };


var searchPagePrefix = exports.searchPagePrefix = 's';

var optionTypes = exports.optionTypes = {
  'buy': 'buy',
  'rent': 'rent',
  'rent-short': 'rent-short' };


var sections = exports.sections = {
  homes: {
    location: 'homes',
    value: 'residence' },

  commercial: {
    location: 'commercial',
    value: 'commercial' },

  projects: {
    location: 'projects',
    value: 'projects' } };



var PROFESSIONALS_TYPES = exports.PROFESSIONALS_TYPES = {
  AGENCY: 'agency',
  MOVING: 'moving',
  MORTGAGE: 'mortgage',
  DESIGNER: 'designer',
  LAWYER: 'lawyer',
  PHOTOGRAPHER: 'photographer',
  APPRAISAL: 'appraisal' };


var PROFESSIONAL_TYPE_BROKER = exports.PROFESSIONAL_TYPE_BROKER = 'broker_community';

var getProfessionalsTypes = exports.getProfessionalsTypes = function getProfessionalsTypes(translate) {return Object.
  values(PROFESSIONALS_TYPES).
  map(function (type) {return { type: type, title: translate('professionalsTypes', type) };});};

var getSectionsNames = exports.getSectionsNames = function getSectionsNames() {return [].concat(Object.values(sections).map(function (section) {return (0, _get2.default)(section, 'location');}), ['projects']);};
var getOptionTypes = exports.getOptionTypes = function getOptionTypes() {return [].concat(Object.values(optionTypes));};

var defaultOptionType = exports.defaultOptionType = optionTypes.buy;

var optionTypesValues = exports.optionTypesValues = [{
  title: 'buy',
  value: optionTypes['buy'] },
{
  title: 'rent',
  value: optionTypes['rent'] },
{
  title: 'rent-short',
  value: optionTypes['rent-short'] }];


var optionTypesValuesWithAll = exports.optionTypesValuesWithAll = [{
  title: 'all_deal_types',
  value: 'all' }].concat(

optionTypesValues);


var optionTypesPropertyLocation = exports.optionTypesPropertyLocation = [{
  title: 'all_location_types',
  value: 'all' },
{
  title: 'israel',
  value: 'local' },
{
  title: 'foreign',
  value: 'foreign' }];




var SORTING_UPDATE_DATE = exports.SORTING_UPDATE_DATE = 'updateDate';
var SORTING_NEWEST_FIRST = exports.SORTING_NEWEST_FIRST = 'newestFirst';
var SORTING_LOWEST_PRICE = exports.SORTING_LOWEST_PRICE = 'lowestPrice';
var SORTING_HIGHEST_PRICE = exports.SORTING_HIGHEST_PRICE = 'highestPrice';
var SORTING_VIEWED_FIRST = exports.SORTING_VIEWED_FIRST = 'viewedFirst';
var SORTING_UNVIEWED_FIRST = exports.SORTING_UNVIEWED_FIRST = 'unviewedFirst';

var leadsSortingConfig = exports.leadsSortingConfig = (_leadsSortingConfig = {}, _leadsSortingConfig[
SORTING_NEWEST_FIRST] = '-created_at', _leadsSortingConfig[
SORTING_LOWEST_PRICE] = 'entity.price', _leadsSortingConfig[
SORTING_HIGHEST_PRICE] = '-entity.price', _leadsSortingConfig[
SORTING_UNVIEWED_FIRST] = 'is_viewed -created_at', _leadsSortingConfig[
SORTING_VIEWED_FIRST] = '-is_viewed -created_at', _leadsSortingConfig);


var sortingOption = exports.sortingOption = [{
  title: 'newestFirst',
  value: 'created_at' },
{
  title: 'updateDate',
  value: 'date' },
{
  title: 'lowestPrice',
  value: 'low price' },
{
  title: 'highestPrice',
  value: 'high price' }];


var publishConfig = exports.publishConfig = {
  sections: ['residence', 'commercial'],
  optionTypes: [].concat(Object.keys(optionTypes)),
  requestTimeout: 30000 };


var socialNetworks = exports.socialNetworks = {
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID,
  TWITTER: 'twitter' };


var CLOUDINARY_CLOUD_NAME = exports.CLOUDINARY_CLOUD_NAME = process.env.CLOUDINARY_CLOUD_NAME || 'habhllegn';
var CLOUDINARY_API_KEY = exports.CLOUDINARY_API_KEY = process.env.CLOUDINARY_API_KEY || '331785392189693';
var CLOUDINARY_API_SECRET = exports.CLOUDINARY_API_SECRET = process.env.CLOUDINARY_API_SECRET || '_z0-VA994OdpBQ6XtHjQcjpKiH4';
var CLOUDINARY_UPLOAD_PRESET = exports.CLOUDINARY_UPLOAD_PRESET = process.env.CLOUDINARY_UPLOAD_PRESET || 'kgztwyr8';
var CLOUDINARY_API_BASE_URL = 'https://api.cloudinary.com';
var CLOUDINARY_BASE_URL = exports.CLOUDINARY_BASE_URL = 'https://res.cloudinary.com';

var cloudinaryContentTypes = exports.cloudinaryContentTypes = {
  IMAGE: 'image',
  VIDEO: 'video' };


var cloudinaryActions = exports.cloudinaryActions = {
  UPLOAD: 'upload',
  DESTROY: 'destroy' };


var getCloudinaryActionUrl = exports.getCloudinaryActionUrl = function getCloudinaryActionUrl(contentType, action) {return (
    CLOUDINARY_API_BASE_URL + '/v1_1/' + CLOUDINARY_CLOUD_NAME + '/' + contentType + '/' + action);};

var getAssetsActionUrl = exports.getAssetsActionUrl = function getAssetsActionUrl(contentType) {return (
    apiURL + '/assets/cloudinary/' + contentType);};

var headerVideo = exports.headerVideo = {
  mp4: CLOUDINARY_BASE_URL + '/' + CLOUDINARY_CLOUD_NAME + '/video/upload/home_promotion/home_video_mp4.mp4',
  ogv: CLOUDINARY_BASE_URL + '/' + CLOUDINARY_CLOUD_NAME + '/video/upload/home_promotion/home_video_ogv.ogv',
  webm: CLOUDINARY_BASE_URL + '/' + CLOUDINARY_CLOUD_NAME + '/video/upload/home_promotion/home_video_webm.webm',
  preloaderJpg: CLOUDINARY_BASE_URL + '/' + CLOUDINARY_CLOUD_NAME + '/image/upload/home_promotion/f_auto/video_preload.jpg' };


var realtorLandingImage = exports.realtorLandingImage = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1556787548/home_promotion/home_page';
var realtorLandingImageMobile = exports.realtorLandingImageMobile = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1556802657/home_promotion/home_page_mobile';
var realtorLandingBottomBackground = exports.realtorLandingBottomBackground = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1560519963/realtors_promotion/bottom_background';
var realtorLandingPackagesBackground = exports.realtorLandingPackagesBackground = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1561029767/realtors_promotion/package_background';
var homePageImage = exports.homePageImage = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto,w_2880/v1556787548/home_promotion/home_page';
var homePageImageMobile = exports.homePageImageMobile = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1556802657/home_promotion/home_page_mobile';
var homePageHomeBanner = exports.homePageHomeBanner = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_60,w_350/v1558013726/home_promotion/home_banner';
var homePageBottomBannerMobile = exports.homePageBottomBannerMobile = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/fzzq9gdfs7jk2dxvb3h7';
var homePageMobileAppBanner = exports.homePageMobileAppBanner = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/qk8g4a2xwm2dp8y0ujoq';
var contactUsRealtorImage = exports.contactUsRealtorImage = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1527237487/jxcq93n8vzfzb6md22tj';
var contactUsRealtorImageMobile = exports.contactUsRealtorImageMobile = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1527252122/lttfp57uuz0528vfnlc1';

var brokerCommunityStamp = exports.brokerCommunityStamp = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1568123728/partners/broker_stamp';
var brokerAssociationStamp = exports.brokerAssociationStamp = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1580467521/partners/realtors_association';
var brokerCommunityLogo = exports.brokerCommunityLogo = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1563433859/partners/broker';
var purpleStamp = exports.purpleStamp = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1590482291/partners/purple_stamp';

var contactUsRealtorDevices = exports.contactUsRealtorDevices = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1536219163/jeyix8kvolpvnfvkwmuy';
var contactUsRealtorDevicesMobile = exports.contactUsRealtorDevicesMobile = CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto,q_auto/v1536219267/d7yed1pcldvssddkufmm';

var getAssetsBaseUrl = exports.getAssetsBaseUrl = function getAssetsBaseUrl(contentType) {return CLOUDINARY_BASE_URL + '/' + CLOUDINARY_CLOUD_NAME + '/' + contentType + '/upload';};

var imageConfig = exports.imageConfig = {
  thumbnailSize: {
    width: 350,
    height: 264,
    crop: 'fill' },

  sliderThumbnailSize: {
    width: 350,
    height: 264,
    crop: 'fill' },

  projectThumbnailSize: {
    width: 350,
    height: 264,
    crop: 'fill' },

  projectDetailsSize: {
    width: 800,
    crop: 'fill' },

  portfolioThumbnail: {
    height: 360,
    width: 360,
    crop: 'fill' },

  propertyThumbnail: {
    width: 350,
    height: 264,
    crop: 'fit' },

  galleryThumbnailMobile: {
    width: 600,
    height: 264,
    crop: 'fill' } };



var imageModifierTypes = exports.imageModifierTypes = {
  THUMBNAIL: 'thumbnail',
  SLIDER_THUMBNAIL: 'sliderThumbnail',
  PROJECT_THUMBNAIL: 'projectThumbnail',
  PROJECT_DETAILS: 'projectDetails',
  LOGO: 'logo',
  PROFESSIONALS_SLIDER: 'professionalsSlider',
  PORTFOLIO_THUMBNAIL: 'portfolioThumbnail',
  PROPERTY_THUMBNAIL: 'propertyThumbnail',
  GALLERY_THUMBNAIL: 'galleryThumbnail',
  GALLERY_THUMBNAIL_MOBILE: 'galleryThumbnailMobile' };


var STATUS_PROJECT = exports.STATUS_PROJECT = {
  planning: 'planning',
  construction: 'construction',
  handover: 'handover' };


var TAB_PROJECT_ID = exports.TAB_PROJECT_ID = {
  main: 'main',
  messageCompany: 'messageCompany',
  advantagesProject: 'advantagesProject',
  summary: 'summary',
  description: 'description',
  aboutCompany: 'aboutCompany',
  developers: 'developers',
  extras: 'extras',
  typesProperties: 'typesProperties',
  contactsForm: 'contactsForm' };


var companyLogoSize = 170;
var professionalsSliderSize = 282;var

thumbnailSize =
imageConfig.thumbnailSize,projectThumbnailSize = imageConfig.projectThumbnailSize,projectDetailsSize = imageConfig.projectDetailsSize,sliderThumbnailSize = imageConfig.sliderThumbnailSize,portfolioThumbnail = imageConfig.portfolioThumbnail,propertyThumbnail = imageConfig.propertyThumbnail,galleryThumbnail = imageConfig.galleryThumbnail,galleryThumbnailMobile = imageConfig.galleryThumbnailMobile;
var thumbnailModifier = exports.thumbnailModifier = 'w_' + thumbnailSize.width + ',h_' + thumbnailSize.height + ',c_' + thumbnailSize.crop + ',f_auto,q_auto';
var sliderThumbnailModifier = exports.sliderThumbnailModifier = 'w_' + sliderThumbnailSize.width + ',h_' + sliderThumbnailSize.height + ',c_' + sliderThumbnailSize.crop + ',f_auto,q_auto';
var projectThumbnailModifier = exports.projectThumbnailModifier = 'w_' + projectThumbnailSize.width + ',h_' + projectThumbnailSize.height + ',c_' + projectThumbnailSize.crop + ',f_auto,q_auto';
var projectDetailsModifier = exports.projectDetailsModifier = 'w_' + projectDetailsSize.width + ',c_' + projectDetailsSize.crop + ',f_auto,q_auto';
var companyLogoAspectFitModifier = exports.companyLogoAspectFitModifier = 'w_' + companyLogoSize + ',c_fit,q_auto';
var professionalsSliderModifier = exports.professionalsSliderModifier = 'w_' + professionalsSliderSize + ',h_' + professionalsSliderSize + ',c_fit,q_30,f_auto';
var portfolioThumbnailModifier = exports.portfolioThumbnailModifier = 'w_' + portfolioThumbnail.width + ',h_' + portfolioThumbnail.height + ',c_' + sliderThumbnailSize.crop + ',q_auto,f_auto';
var propertyModifier = exports.propertyModifier = 'w_' + propertyThumbnail.width + ',h_' + propertyThumbnail.height + ',c_' + propertyThumbnail.crop + ',f_auto,q_auto';
var galleryModifier = exports.galleryModifier = 'c_scale,w_' + projectThumbnailSize.width + ',h_' + projectThumbnailSize.height + ',c_' + projectThumbnailSize.crop + ',f_auto,q_auto';
var galleryModifierMobile = exports.galleryModifierMobile = 'c_scale,w_' + galleryThumbnailMobile.width + ',h_' + galleryThumbnailMobile.height + ',c_' + galleryThumbnailMobile.crop + ',f_auto,q_auto';

var fullModifier = exports.fullModifier = 'q_auto,f_auto';
var videoFullModifier = exports.videoFullModifier = 'vc_auto,q_70';

var propertyDefaultImage = exports.propertyDefaultImage = '/images/property-default-image.svg';

var enterKey = exports.enterKey = 13;
var escKey = exports.escKey = 27;
var leftKey = exports.leftKey = 37;
var rigthKey = exports.rigthKey = 39;

var sentry = exports.sentry = {
  key: process.env.SENTRY_PUBLIC_KEY,
  ravenUrl: 'https://cdn.ravenjs.com/3.20.0/raven.min.js' };


var reactSelectStyles = exports.reactSelectStyles = 'https://unpkg.com/react-select@1.2.0/dist/react-select.css';
var swiperStyles = exports.swiperStyles = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.1.0/css/swiper.min.css';

var inputStyleTheme = exports.inputStyleTheme = {
  container: 'form-group--input form-group',
  containerOpen: 'form-group--input form-group',
  input: 'location-input__input',
  suggestionsContainer: 'location-input__suggestions-container',
  suggestionsList: 'location-input__suggestions-list',
  suggestion: 'location-input__suggestion',
  suggestionFocused: 'location-input__focused',
  sectionContainer: 'location-input__section-container',
  sectionTitle: 'location-input__section-title' };


var requestErrorStatusCodes = exports.requestErrorStatusCodes = {
  BAD_REQUEST: 400,
  TOKEN_VALIDATION_ERROR: 401 };


var temporaryEmailEnding = exports.temporaryEmailEnding = 'onmap-temp.co.il';

var supportEmail = exports.supportEmail = 'support@onmap.co.il';
var getSupportEmail = exports.getSupportEmail = function getSupportEmail(isAgent) {return (isAgent ? 'realtor' : 'support') + '@onmap.co.il';};

var ourContacts = exports.ourContacts = {
  phone: '054-613-7700',
  address: {
    he: 'אליעזר מזל 4, ראשון לציון',
    en: 'Eliezer Mazal St 4, Rishon LeTsiyon',
    ru: 'Eliezer Mazal St 4, Ришон ле-Цион',
    fr: 'Eliezer Mazal St 4, Rishon LeTsiyon' } };



var pinInfoWindowMetrics = exports.pinInfoWindowMetrics = {
  MARGIN: 10,
  DEFAULT_OFFSET_Y: -40,
  REVERSE_OFFSET_Y: -5,
  ARROW_WIDTH: 14,
  ARROW_HEIGHT: 22 };


var mapboxPinInfoWindowMetrics = exports.mapboxPinInfoWindowMetrics = {
  MARGIN: 10,
  DEFAULT_OFFSET_Y: -25,
  REVERSE_OFFSET_Y: 10,
  ARROW_WIDTH: 20,
  ARROW_HEIGHT: 10 };


var phoneNumberRegex = exports.phoneNumberRegex = /^[+|\d]((\d+)?[- ]?)?([\d\- ]+)?$/;
var phoneСodeCountryRegex = exports.phoneСodeCountryRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/;

var israelCode = exports.israelCode = '972';

var subscriptionGeneralTopicId = exports.subscriptionGeneralTopicId = isProd ? 'BkblEz-NM' : 'HJ7inZWEf';
var realEstateTermsDefinitionsArticleId = isProd ? 'rJyHQYLzf' : 'H14dtFfbf';

var realEstateTermsDefinitionsLink = exports.realEstateTermsDefinitionsLink = {
  name: 'termsDefinitions',
  link: 'articles/' + realEstateTermsDefinitionsArticleId };


var alwaysDisplayedPropertyData = exports.alwaysDisplayedPropertyData = ['parkingSpots', 'elevator'];

var localesWithShortenFooterLinks = exports.localesWithShortenFooterLinks = [
'en', 'ru', 'fr'];


var localesWithEnglishAddress = exports.localesWithEnglishAddress = [
'ru', 'fr'];


var languageFontOverride = exports.languageFontOverride = {
  he: 'Assistant' };


var contactUsUsage = exports.contactUsUsage = {
  generic: 'GENERIC',
  agent: 'AGENT',
  realtorPackages: 'REALTOR_PACKAGES',
  commercial: 'COMMERCIAL',
  projects: 'PROJECTS',
  modal: 'MODAL' };


var propertyFiltersInitialValues = exports.propertyFiltersInitialValues = {
  rooms: [],
  types: [],
  price: {} };


var advancedFiltersInitialValues = exports.advancedFiltersInitialValues = {
  floor: {},
  notLastFloor: null,
  parkingSpot: null,
  elevator: null,
  balcony: null,
  photos: null,
  vr: null,
  commodities: [],
  price: {},
  toilets: [],
  bathrooms: [],
  area: {},
  constructionYear: {} };


var initialFieldsValuesForMobileFilters = exports.initialFieldsValuesForMobileFilters = {
  location: '',
  rooms: ['all'],
  propertyTypes: ['all'],
  status: ['all'],
  minPrice: '',
  maxPrice: '' };


var clearFiltersInitialValues = exports.clearFiltersInitialValues = {
  pointCoordinates: null,
  drawnPoly: null,
  locationSearch: {
    location: {
      lat: 31.9430284,
      lon: 34.79678230000002 },

    map: {
      bottomleft: {
        lat: 31.665551850737263,
        lon: 34.42050056171877 },

      topright: {
        lat: 32.21966963949583,
        lon: 35.17306403828127 } },


    zoom: 11 },

  params: Object.assign({},
  propertyFiltersInitialValues,
  advancedFiltersInitialValues, {
    commodities: [] }) };



var cleanModalStyle = exports.cleanModalStyle = {
  overlay: {
    position: 'static',
    top: 'unset',
    left: 'unset',
    right: 'unset',
    bottom: 'unset',
    backgroundColor: '#fff' },

  content: {
    position: 'static',
    top: 'static',
    left: 'static',
    right: 'static',
    bottom: 'static',
    border: '0',
    background: '#fff',
    overflow: 'initial',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '0',
    outline: 'none',
    padding: '0' } };



var centeredModalStyle = exports.centeredModalStyle = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center' },

  content: {
    position: 'relative',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    top: 'auto',
    overflowX: 'hidden',
    borderRadius: '2px',
    maxHeight: '100%' } };



var appStoreId = exports.appStoreId = '1227792122';
var appStoreLink = exports.appStoreLink = 'https://itunes.apple.com/app/id' + appStoreId;
var playmarketLink = exports.playmarketLink = 'https://play.google.com/store/apps/details?id=il.co.onmap.android';
var filtersHeight = exports.filtersHeight = 50;
var mobileFiltersHeight = exports.mobileFiltersHeight = 45;
var mobileFavoritesSwitcherHeight = exports.mobileFavoritesSwitcherHeight = 60;
var desktopHeaderHeight = exports.desktopHeaderHeight = 95;
var mobileHeaderHeight = exports.mobileHeaderHeight = 60;
var searchFooterHeight = exports.searchFooterHeight = 208;
var mobileHiddenFooterPart = exports.mobileHiddenFooterPart = 215;
var desktopHiddenFooterPart = exports.desktopHiddenFooterPart = 292;
var viewsPeriodOnChart = exports.viewsPeriodOnChart = 10;

var mouseFlowSiteId = exports.mouseFlowSiteId = process.env.MOUSEFLOW_SITE_KEY || '5fe3804b-1e37-4d09-98b5-78881929a57c';

var countOfPropertiesShowTime = exports.countOfPropertiesShowTime = 5000;

var analyticsEventAction = exports.analyticsEventAction = {
  VIEW: 'view',
  CLICK: 'click',
  SHOW_CONTACT: 'show-contact',
  SHARE: 'share',
  CONTACT: 'contact',
  FAVOURITES: 'favourites',
  SHOW_NUMBER: 'show-number' };


var issueTypes = exports.issueTypes = {
  GENERAL: 'general',
  ADDRESS: 'address' };


var reportTypes = exports.reportTypes = {
  PROPERTY: 'property',
  PUBLISH: 'publish',
  ARTICLE: 'article',
  COMPANY: 'company' };


var myAccountViews = exports.myAccountViews = {
  MY_ACCOUNT: 'edit',
  MY_SEARCHES: 'searches',
  MY_LEADS: 'leads',
  MY_PROJECTS: 'my_projects',
  MY_COMPANY: 'my_company',
  REALTOR_PAGE: 'realtor_page',
  MY_STAFF: 'my_staff',
  FAVORITES: 'favorites',
  LEADS: 'leads',
  MY_SUBSCRIPTIONS: 'my_subscriptions' };


var myStaffViews = exports.myStaffViews = {
  PRIMARY: 'primary',
  LISTED: 'listed' };


var privacyTermsTabs = exports.privacyTermsTabs = {
  PRIVACY: 'privacy',
  TERMS: 'terms' };


var constructionYearMin = exports.constructionYearMin = 1900;
var constructionYearMax = exports.constructionYearMax = 2027;
var VAT = exports.VAT = 18;


var cloudinaryBaseUrls = exports.cloudinaryBaseUrls = {
  logoBaseUrl: CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/v1516886360/general/logo',
  packageIconsBaseUrl: CLOUDINARY_BASE_URL + '/onmap-prod/image/upload/f_auto/v1516887098/publish' };


var onMapLogoBlue = exports.onMapLogoBlue = cloudinaryBaseUrls.logoBaseUrl + '/blue';
var onMapLogoWhite = exports.onMapLogoWhite = cloudinaryBaseUrls.logoBaseUrl + '/white';
var onMapLogoMobile = exports.onMapLogoMobile = cloudinaryBaseUrls.logoBaseUrl + '/icon_white';
var onMapLogoMobileBlue = exports.onMapLogoMobileBlue = cloudinaryBaseUrls.logoBaseUrl + '/icon_blue';
var onMapLogoSocials = exports.onMapLogoSocials = cloudinaryBaseUrls.logoBaseUrl + '/social';


var packageIcons = exports.packageIcons = {
  withoutHighlight: cloudinaryBaseUrls.packageIconsBaseUrl + '/realtor_package_preview_1.png',
  withHighlight: cloudinaryBaseUrls.packageIconsBaseUrl + '/realtor_package_preview_2.png' };


var projectStatuses = exports.projectStatuses = [
{
  name: 'planning',
  localisation: {
    he: 'בתכנון',
    en: 'Planning',
    ru: 'Планирование' } },


{
  name: 'construction',
  localisation: {
    he: 'בבניה',
    en: 'Construction',
    ru: 'Строительство' } },


{
  name: 'handover',
  localisation: {
    he: 'מוכן לאכלוס',
    en: 'Handover',
    ru: 'Готово к заселению' } }];




var publishProjectFormFieldsForSave = exports.publishProjectFormFieldsForSave = [
'architect',
'owner',
'contractor',
'name_project',
'status',
'property_types',
'minimal_price',
'phone_number',
'summary',
'description',
'completion_date_months',
'completion_date_years',
'room_range',
'commodities',
'project_img',
'ownerImg',
'contractorImg',
'architectImg',
'projectImages',
'address',
'exact_price',
'projectPerformers',
'currency',
'advantages',
'buildings',
'apartments',
'floors'];


var publishFormFieldsForSave = exports.publishFormFieldsForSave = [
'customerType',
'section',
'search_option',
'sub_option',
'property_type',
'address',
'area',
'rooms',
'floor',
'groundFloor',
'parking',
'balconies',
'bathrooms',
'toilets',
'construction_year',
'light_direction',
'elevators',
'description',
'price',
'entry_date',
'contacts',
'payments',
'images',
'videos',
'hasBasement',
'commodities',
'balconies_area'];


var columnOptions = exports.columnOptions = function columnOptions(translate) {return [
  { value: 'dealType', label: translate('managePage', 'dealType').toString() },
  { value: 'status', label: translate('managePage', 'status').toString() },
  { value: 'address', label: translate('managePage', 'address').toString() },
  { value: 'propertyType', label: translate('managePage', 'propertyType').toString() },
  { value: 'price', label: translate('managePage', 'price').toString() },
  { value: 'share', label: translate('managePage', 'share').toString() },
  { value: 'activePromotion', label: translate('managePage', 'activePromotion').toString() },
  { value: 'rooms', label: translate('managePage', 'rooms').toString() },
  { value: 'floor', label: translate('managePage', 'floor').toString() },
  { value: 'images', label: translate('managePage', 'images').toString() },
  { value: 'exposures', label: translate('managePage', 'exposures').toString() },
  { value: 'phoneClicksCount', label: translate('managePage', 'phoneClicksCount').toString() },
  { value: 'favouritesCount', label: translate('managePage', 'favouritesCount').toString() }];};


var columnsDefaultState = exports.columnsDefaultState = [
{ name: 'dealType', disabled: true },
{ name: 'status', disabled: false },
{ name: 'address', disabled: true },
{ name: 'propertyType', disabled: true },
{ name: 'price', disabled: true },
{ name: 'rooms', disabled: false },
{ name: 'floor', disabled: false },
{ name: 'images', disabled: false },
{ name: 'exposures', disabled: false },
{ name: 'share', disabled: true },
{ name: 'activePromotion', disabled: true },
{ name: 'phoneClicksCount', disabled: false },
{ name: 'favouritesCount', disabled: false }];



var getFilteredPropertyTypes = exports.getFilteredPropertyTypes = function getFilteredPropertyTypes() {var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var optionType = arguments[1];return optionType === optionTypes.buy ?
  types.filter(function (type) {return type !== 'room';}) :
  types;};


var formatImageLink = exports.formatImageLink = function formatImageLink(_ref) {var link = _ref.link,angle = _ref.angle,_ref$modifier = _ref.modifier,modifier = _ref$modifier === undefined ? thumbnailModifier : _ref$modifier;
  var baseUrl = getAssetsBaseUrl(cloudinaryContentTypes.IMAGE);
  return baseUrl + '/' + modifier + ',a_' + angle + '/' + link;
};


var managePropertyActions = exports.managePropertyActions = {
  DEACTIVATE: 'deactivate',
  JUMP: 'jump' };


var googleAdClient = exports.googleAdClient = process.env.GOOGLE_AD_CLIENT || 'ca-pub-8088109255506070';

var publishFormLocationErrors = exports.publishFormLocationErrors = new Set([
'ADDRESS_IS_CITY',
'HOUSE_NOT_EXISTS',
'HOUSE_IS_REQUIRED',
'ADDRESS_IS_INCOMPLETE']);


var publishFormErrorNames = exports.publishFormErrorNames = {
  houseDoesntExist: 'HOUSE_NOT_EXISTS',
  houseIsRequired: 'HOUSE_IS_REQUIRED',
  addressIsIncomplete: 'ADDRESS_IS_INCOMPLETE',
  addressIsCity: 'ADDRESS_IS_CITY',
  addressWasNotCreated: 'ADDRESS_WAS_NOT_CREATED',
  messageErrorAddress: 'MESSAGE_ERROR_ADDRESS' };


var fbLink = exports.fbLink = 'https://www.facebook.com/onmapltd';

var MAIN_IMAGES = exports.MAIN_IMAGES = (_MAIN_IMAGES = {}, _MAIN_IMAGES[
PROFESSIONALS_TYPES.AGENCY] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652201/professionals/agency', _MAIN_IMAGES[
PROFESSIONALS_TYPES.MORTGAGE] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652201/professionals/morgage', _MAIN_IMAGES[
PROFESSIONALS_TYPES.MOVING] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652201/professionals/moving', _MAIN_IMAGES[
PROFESSIONALS_TYPES.DESIGNER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652201/professionals/designer', _MAIN_IMAGES[
PROFESSIONAL_TYPE_BROKER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1579165159/partners/broker_main_image', _MAIN_IMAGES[
PROFESSIONAL_TYPE_BROKER + '_ltr'] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1579176864/partners/broker_main_image_ltr', _MAIN_IMAGES[
PROFESSIONALS_TYPES.LAWYER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1586788387/professionals/lawyer', _MAIN_IMAGES[

PROFESSIONALS_TYPES.PHOTOGRAPHER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1586859754/professionals/photographers_2', _MAIN_IMAGES[
PROFESSIONALS_TYPES.APPRAISAL] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1586788387/professionals/appraisal', _MAIN_IMAGES);


var MAIN_IMAGES_MOBILE = exports.MAIN_IMAGES_MOBILE = (_MAIN_IMAGES_MOBILE = {}, _MAIN_IMAGES_MOBILE[
PROFESSIONALS_TYPES.AGENCY] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652200/professionals/agency_mobile', _MAIN_IMAGES_MOBILE[
PROFESSIONALS_TYPES.MORTGAGE] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652201/professionals/morgage_mobile', _MAIN_IMAGES_MOBILE[
PROFESSIONALS_TYPES.MOVING] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652200/professionals/moving_mobile', _MAIN_IMAGES_MOBILE[
PROFESSIONALS_TYPES.DESIGNER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573652200/professionals/designer_mobile', _MAIN_IMAGES_MOBILE[
PROFESSIONAL_TYPE_BROKER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1579165321/partners/photo_for_broker_mobile', _MAIN_IMAGES_MOBILE[
PROFESSIONALS_TYPES.LAWYER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1586788502/professionals/lawyer_mobile', _MAIN_IMAGES_MOBILE[
PROFESSIONALS_TYPES.PHOTOGRAPHER] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1586788501/professionals/photographer_mobile', _MAIN_IMAGES_MOBILE[
PROFESSIONALS_TYPES.APPRAISAL] = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1586788502/professionals/appraisal_mobile', _MAIN_IMAGES_MOBILE);


var DEFAULT_MAIN_IMAGE = exports.DEFAULT_MAIN_IMAGE = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/realtors_promotion/realtor_landing';

var DEFAULT_DESCRIPTION_LENGTH = exports.DEFAULT_DESCRIPTION_LENGTH = 480;

var COUNTRIES_LIST = exports.COUNTRIES_LIST = {
  COUNT_COUNTRY_IN_LIST: 14,
  COUNT_COUNTRY_IN_LIST_MOBILE: 5 };


var ROUTES_PATHS = exports.ROUTES_PATHS = {
  FOREIGN: 'foreign' };


var ROUTES_ADDITIONAL = exports.ROUTES_ADDITIONAL = {
  FOREIGN_SEARCH: 'search' };


var ENTITY_TYPES = exports.ENTITY_TYPES = {
  PROJECT: 'project',
  PROPERTY: 'property' };


var ERROR_KEYS = exports.ERROR_KEYS = {
  MISSING_PROPERTY: 'MISSING_PROPERTY_CONTACT_INFORMATION' };


//////////////////
// WEBPACK FOOTER
// ./src/constants.js
// module id = 4
// module chunks = 0